import { utcDay, utcSaturday, utcMonday } from 'd3-time';
import { base } from './skipWeekends';
export default (function () {
  return base(function (date) {
    return date.getUTCDay();
  }, utcDay, utcSaturday, utcMonday);
});